import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import Card from '@dashboard/components/Card';
import CardContent from '@dashboard/components/CardContent';
import Link from '@dashboard/components/Link';
import PropertyList from '@dashboard/components/PropertyList';
import OrderDetailsTable from './OrderDetailsTable';

/** A card on an order page: heading outside, with an optional control at its right. */
export const OrderCard = ({ title, action, children }) => (
  <Card className="mx-auto">
    <CardContent>
      <PropertyList.Title>
        {title}
        {action ? <div className="mt-auto ml-auto">{action}</div> : null}
      </PropertyList.Title>
      {children}
    </CardContent>
  </Card>
);

export const OrderTableCard = ({ title, action, rows }) => (
  <OrderCard title={title} action={action}>
    <OrderDetailsTable rows={rows} />
  </OrderCard>
);

export const TitleLink = ({ to, children }) => (
  <Link to={to} className="flex items-center gap-x-1 whitespace-nowrap text-sm">
    {children} <ArrowRightIcon className="w-4 h-4" />
  </Link>
);
